/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Container,
  Row,
  Button
} from "reactstrap";

// core components
import samplePDF from 'assets/pdf/Health & Safety Policy.pdf';

function FooterBlack() {
  return (
    <>
      <footer className="footer footer-white" style={{
        backgroundImage:
          "url(" + require("assets/img/color.jpg") + ")",
      }}>
        <Container>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <Link to="/FAQ">
                    <strong style={{ color: "#000000" }}>FAQ</strong>
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us">
                    <strong style={{ color: "#000000" }}>Contact Us</strong>
                  </Link>
                </li>
                <li style={{ padding: "2px" }}>
                  <Button
                    className="btn btn-just-icon btn-link btn-facebook"
                    color="neutral"
                    href="https://www.facebook.com/SMART.event.and.production/"
                  >
                    <i className="fa fa-facebook" />
                  </Button>
                </li>
                <li style={{ padding: "2px" }}>
                  <Button
                    className="btn btn-just-icon btn-link btn-instagram"
                    color="neutral"
                    href="https://www.instagram.com/smart_event_q/"
                  >
                    <i className="fa fa-instagram" />
                  </Button>
                </li>
                <li>
                  <a href="https://www.google.com/maps/dir//25.3228169,51.5265508/@25.322817,51.526551,17z?hl=en-US">
                    <strong style={{ color: "#000000" }}>Our Location</strong>
                  </a>
                </li>
                <li>
                  <Link to={samplePDF} target="_blank">
                    <strong style={{ color: "#000000" }}>Health {`&`} Safety</strong>
                  </Link>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <Link to="/login">
                <strong style={{ color: "#000000" }}>Employee Login</strong>
              </Link>
              &nbsp;
              &nbsp;
              &nbsp;
              <span className="copyright" style={{ color: "#000000" }}>
                <strong>
                  © {new Date().getFullYear()}
                </strong>
              </span>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default FooterBlack;
